import React, { useState } from 'react';
import './TokenCarousel.css';

function TokenCarousel({ tokens }) {
  const [tokenIndex, setTokenIndex] = useState(0);
  const [imagesLoaded, setImageLoaded] = useState(new Set());

  const viewPrevToken = () => {
    console.log("prev called");
    setTokenIndex(tokenIndex => Math.max(tokenIndex - 1, 0));
  }

  const viewNextToken = () => {
    setTokenIndex(tokenIndex => Math.min(tokenIndex + 1, tokens.length - 1));
  }

  const { image, name } = tokens[tokenIndex];
  const leftDisabled = tokenIndex <= 0;
  const rightDisabled = tokenIndex >= tokens.length - 1;
  const tokenCount = tokens.length;
  const imageLoaded = imagesLoaded.has(tokenIndex);
  return (<div id="nft-successful" className="nft-modal-section">
    {tokenCount > 1 && <div className="columns is-mobile">
      <div className="column has-text-centered">
        <p className="title is-4">{tokenIndex+1}/{tokens.length}</p>
      </div>
    </div>
    }
    <div className="columns is-vcentered is-mobile ">
      {tokenCount > 1 && 
      <div className="column is-1 token-carousel-left-panel is-clickable" onClick={viewPrevToken}>
        <i className={`fa fa-chevron-circle-left token-carousel-left ${leftDisabled ? "disabled" : ""}`}></i>
      </div>}
      <div className="column has-text-centered">
        <p style={{display: imageLoaded ? "none" : "block"}}>Loading {name}'s Image</p>
        <div style={{display: imageLoaded ? "block" : "none"}}>
          <img 
            className="token-image" 
            src={`https://canuckz.mypinata.cloud/ipfs/${image.slice(7)}`} 
            alt="Your token"
            onLoad={()=> setImageLoaded(images => new Set(images.add(tokenIndex)))}
            />
          <p><b>{name}</b></p>
        </div>
      </div>
      {tokenCount > 1 && 
      <div className="column is-1 token-carousel-right-panel is-clickable" onClick={viewNextToken}>
        <i className={`fa fa-chevron-circle-right token-carousel-right is-pulled-right ${rightDisabled ? "disabled" : ""}`}></i>
      </div>}
    </div>
  </div>);
}


export default TokenCarousel;